import * as React from 'react';

import { PhotoModel } from '@App/common/models'

import './homePhoto.css'

export interface IHomePhotoProps {
  photo: PhotoModel,
}

export interface IHomePhotoState {
  ar: number;
}

export default class IHomePhoto extends React.PureComponent<IHomePhotoProps, IHomePhotoState> {
  constructor(props: IHomePhotoProps){
    super(props);

    this.state = { ar: this.getAR()};

    console.log(window.innerWidth);
    this.getAR = this.getAR.bind(this);
    this.updateAR = this.updateAR.bind(this);
  } 
  
  public render() {
    return (
      <div className={ this.getClassName() }>
        <img src={ this.props.photo.displaySrc }/>
      </div>
    );
  }

  public componentDidMount() {
    window.addEventListener('resize', this.updateAR);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.updateAR);
  }

  public getAR = (): number => {
    return window.innerWidth / window.innerHeight;
  }

  public updateAR(){ console.log(this.getAR())
    this.setState({ar: this.getAR()});
  }

  private getClassName(): string{
    let cname = '';
    if (this.state.ar > 1.5) {
      cname = 'home_image';
    } else if (this.state.ar > 1 && this.state.ar < 1.5) {
      cname = 'home_image';
    } else {
      cname = 'home_image';
    }
    return cname;
   }
}



// WEBPACK FOOTER //
// ./src/bundles/home/components/home/homePhoto/homePhoto.tsx